import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { setTournamentCreated } from 'modules/auth/store';
import { toast } from 'react-toastify';
import { restApi } from 'shared/api/rest-api';

import { Organizer } from '../../domain/interfaces/organizer';
import { UpsertOrganizerInput } from '../../domain/interfaces/upsert-organizer-input';
import organizerRepository from '../../domain/repositories/organizer-repository';
import organizerResource from '../../domain/resources/organizer-resource';

const PREFIX = 'organizer';

export const fetchOrganizer = createAsyncThunk<Organizer | null, { tournamentId: number }>(
  `${PREFIX}/fetchOrganizer`,
  async (payload, { rejectWithValue }) => {
    try {
      const organizer = await organizerRepository.fetchOrganizer(payload.tournamentId);
      if (!organizer) return null;

      return organizer;
    } catch (error) {
      console.error(`${PREFIX}/fetchOrganizers error:`, error);
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  },
);

export const upsertOrganizer = createAsyncThunk<Organizer, UpsertOrganizerInput>(
  `${PREFIX}/upsertOrganizer`,
  async (payload, { dispatch }) => {
    const { id, name, description, phone, email, address, sportType, adminUserId, logo } = payload;

    try {
      let organizer = await organizerRepository.upsertOrganizer({
        id,
        name,
        description,
        phone,
        email,
        address,
        sportType,
        adminUserId,
      });

      // Список доступных организаторов живёт в кэше RTK Query — сбрасываем его,
      // чтобы созданный турнир появился на странице выбора
      dispatch(restApi.util.invalidateTags([{ type: 'Tournament', id: 'PARTIAL-LIST' }]));
      dispatch(setTournamentCreated(organizer.id));

      if (logo) {
        await organizerResource.uploadLogo(organizer.id, logo);
        const updated = await organizerRepository.fetchOrganizer(organizer.id);
        if (updated) {
          organizer = updated;
        }
      }

      toast.success(i18n.t('settings.saveSettingsSuccess'));

      return organizer;
    } catch (err) {
      console.error(`${PREFIX}/upsertOrganizer error:`, err);
      toast.error(i18n.t('settings.saveSettingsInternalError'));

      throw err;
    }
  },
);

export const resetOrganizer = createAction(`${PREFIX}/resetOrganizer`);
